<template>
  <div class="solution-box">
    <div v-for="(solution, idx) in solutionList" :key="solution.id">
      <BaseAnimated  :threshold="0.5">
        <ProductadvSolveDescribeContentLeft v-if="solution.num%2!==0" :solution="solution"/>
        <ProductadvSolveDescribeContentRight v-else :solution="solution"/>
      </BaseAnimated>
    </div>
  </div>
</template>

<script setup>
import { findProductAdvSolveList } from "/composables/api/productadv";

const solutionList = ref([]);
const params = {}

// 从API获取解决方案列表
findProductAdvSolveList(params).then(res => {
  solutionList.value = res.data;
})
</script>

<style lang='less' scoped>
.solution-box {
  div {
    width: 100%;
    max-height: 30vh;
    margin-top: 5vh;
    min-height: 400px;
  }
}
</style>
